
import React from "react";
import "./CreateClient.css";

type propsData = {
    license: string
    setLicense: (license: string) => void,
    facebookId: string,
    setFacebookId: (facebookId: string) => void,
    instagramId: string,
    setInstagramId: (instagramId: string) => void,
    accessToken: string,
    setAccessToken: (accessToken: string) => void,
}

function LicFbInstaTkn({ license, setLicense, facebookId, setFacebookId, instagramId, accessToken, setAccessToken, setInstagramId }: propsData) {

    return(
        <div className="LicFbInstaTkn">
            <div className="createClient-form-type mrg-btm">
                <div className="form-type-box">
                    <label>License Number</label>
                </div>
                <div className="form-type-box">
                    <input
                        className = "type-box-type-input"
                        type = "text"
                        value = { license }
                        onChange = {e => setLicense(e.target.value)}
                    />
                </div>
            </div>
            <div className="createClient-form-type mrg-btm">
                <div className="form-type-box">
                    <label>Facebook ID</label>
                </div>
                <div className="form-type-box">
                    <input
                        className = "type-box-type-input"
                        type = "text"
                        value = { facebookId }
                        onChange = {e => setFacebookId(e.target.value)}
                    />
                </div>
            </div>
            <div className="createClient-form-type mrg-btm">
                <div className="form-type-box">
                    <label>Instagram ID</label>
                </div>
                <div className="form-type-box">
                    <input
                        className = "type-box-type-input"
                        type = "text"
                        value = { instagramId }
                        onChange = { e => setInstagramId(e.target.value) }
                    />
                </div>
            </div>
            <div className="createClient-form-type mrg-btm">
                <div className="form-type-box">
                    <label>Access Token</label>
                </div>
                <div className="form-type-box">
                    <input
                        className = "type-box-type-input"
                        type = "text"
                        value = { accessToken }
                        onChange = { e => setAccessToken(e.target.value) }
                    />
                </div>
            </div>
        </div>
    )
}

export default LicFbInstaTkn
